module.exports = require('./lib/no-important.js');



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/aphrodite/no-important.js
// module id = 698
// module chunks = 1 2 3